import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Content } from 'LegacySBCRA/Content/Content';

import { isFuelTypeUlez } from '../UlezPage.helpers';
import type { UlezVehicle } from '../UlezPage.types';
import LocalTexts from '../ulezText.json';

import styles from './Emission.scss';

const LocalT = new MDText(LocalTexts);

const ratingReference = {
  A: styles.a,
  B: styles.b,
  C: styles.b,
  D: styles.d,
  E: styles.d,
  F: styles.f,
  G: styles.f,
  H: styles.h,
  I: styles.h,
  J: styles.j,
  K: styles.j,
  L: styles.l,
  M: styles.l,
  null: styles.a,
};

const ELECTRIC = 'Electric';

type EmissionProps = {
  electricCar: boolean;
  euroStatusHasValue: boolean;
  showEmissionRating: boolean;
  vehicle?: UlezVehicle;
}

export const Emission = ({
  electricCar, euroStatusHasValue, showEmissionRating, vehicle,
}: EmissionProps) => {
  const {
    emissionRating, emissions, euroStatus,
    isCompliant,
  } = vehicle || {};

  if (!euroStatusHasValue && isCompliant) {
    return null;
  }

  let complianceText = isCompliant ? 'compliant' : 'notCompliant';
  const fuel = vehicle?.fuel?.toLowerCase();
  const isEuroStatus3 = euroStatus === '3';
  complianceText = isEuroStatus3 ? 'euro3' : complianceText;

  return (
    <div className={cx(styles.container, {
      [styles.notCompliant]: !isCompliant && !isEuroStatus3,
      [styles.euroStatus3]: isEuroStatus3,
    })}
    >
      <Content>
        { !isCompliant && !isEuroStatus3
        && (
          <>
            <h3 className={styles.subTitle}>
              {LocalT.translate('results.emission.info.notCompliant.subTitle', { fuel })}
            </h3>
            <ul className={styles.list}>
              {isFuelTypeUlez(fuel) && LocalTexts.results.emission.info.notCompliant[fuel]?.map((item: string) => (
                <li key={item}>
                  {LocalT.translate(item, {
                    sub: <sup>{LocalT.translate('results.emission.ratingSub')}</sup>,
                  })}
                </li>
              ))}
            </ul>
          </>
        )}

        <section>
          <h3>
            {LocalT.translate(`results.emission.info.${complianceText}.title`)}
          </h3>
          <div className={styles.boxBlock}>
            <div className={styles.box}>
              <h6>
                {LocalT.translate('results.emission.category')}
              </h6>
              <p>
                {
                  electricCar ? (
                    ELECTRIC
                  ) : (
                    LocalT.translate('results.emission.type', { type: euroStatus })
                  )
                }
              </p>
            </div>

            {showEmissionRating && (
              <div className={cx(styles.box, styles.emissionBox)}>
                <h6 className={styles.sup}>
                  {LocalT.translate('results.emission.rating', {
                    sub: <sup>{LocalT.translate('results.emission.ratingSub')}</sup>,
                  })}
                </h6>
                <span className={cx(styles.emission, ratingReference[emissionRating as keyof typeof ratingReference])}>
                  {emissionRating ? (
                    LocalT.translate('results.emission.ratingInfo', {
                      type: emissionRating,
                      value: emissions || 0,
                    })
                  ) : (
                    LocalT.translate('results.emission.ratingInfoOnlyValue', {
                      value: 0,
                    })
                  )}
                </span>
              </div>
            )}
          </div>
        </section>
      </Content>
    </div>
  );
};
